/* eslint-disable no-unused-vars */
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const sandConfig = {
  apiKey: 'AIzaSyATVTdLme9mJk_y2ul1K2bcg6HRujXyf_w',
  authDomain: 'fireswan-pro.firebaseapp.com',
  databaseURL: 'https://fireswan-pro.firebaseio.com',
  projectId: 'fireswan-pro',
  storageBucket: 'fireswan-pro.appspot.com',
};

const prodConfig = {
  apiKey: 'AIzaSyAySsMkexDQ4JtDzX3DTmygk-IWRCGzns4',
  authDomain: 'fireswan-production.firebaseapp.com',
  databaseURL: 'https://fireswan-production.firebaseio.com',
  projectId: 'fireswan-production',
  storageBucket: 'fireswan-production.appspot.com',
};

firebase.initializeApp(prodConfig);

export const facebookProvider = new firebase.auth.FacebookAuthProvider();

export default firebase;
